export const PREPARING_LESSON_REPORT_TEXT =
  'Preparing Lesson Report (This could take a minute)'
export const DOWNLOAD_LESSON_REPORT_TEXT = 'Download K8 Lesson Report (CSV)'
export const DOWNLOAD_HS_LESSON_REPORT_TEXT =
  'Download HS Lesson Report (CSV)'
export const SITE_PREFERENCES_MODAL_TITLE = 'Site Preferences'
export const NO_SITE_PREFERENCES_TEXT = 'No preferences found for this site.'
